import { render, staticRenderFns } from "./com-edit-coupon.vue?vue&type=template&id=4a63c57c&"
import script from "./com-edit-coupon.vue?vue&type=script&lang=js&"
export * from "./com-edit-coupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports